import { useTranslation } from 'react-i18next'
import { useStyletron } from 'baseui'

const useDevTools = () => {
  const { t } = useTranslation('devToolsNew')
  const [css, theme] = useStyletron()
  return {
    t,
    css,
    theme
  }
}

export default useDevTools
